// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mz-Fi","label":"styles_label__3J4p-"};